import _ from "lodash";

export function getGroups (index, data) {
    const { groups } = data.assetAllocation;
    const y1AxisData = getAssetsAllocation({}, data);

    return _.map(groups, group => {
        return {
            name: group.name,
            value: group.value,
            items: _
                .chain(y1AxisData)
                .filter(y => y.group === group.id)
                .map(groupItem => {
                    return {
                        color: groupItem.color,
                        value: groupItem.computedValues[index].value,
                        name: groupItem.name
                    };
                })
                .value()
        };
    });
}

export function getTdfRetirementYear (yearFromRetirement, data) {
    const retirementYear = _
        .chain(data.mapRetirementYear.slice(0))
        .map((retirementYear, i) => _.assign({}, retirementYear, { index: i }))
        .find(retirementYear => {
            let { min, max } = retirementYear;

            if (!min) {
                min = -1000;
            }
            if (!max) {
                max = 1000;
            }

            return yearFromRetirement >= min && yearFromRetirement <= max;
        })
        .value();

    return Object.assign(
        retirementYear,
        { labelValue: retirementYear.value },
        { value: data.assetAllocation.xDomain[retirementYear.index] }
    );
}

export function getAssetsAllocation (val, data) {
    return _.map(data.assetAllocation.y1AxisData, (v) => {
        return Object.assign(v, {
            computedValues: _.map(v.values, (rawValue, i) => {
                const xDomain = data.assetAllocation.xDomain[i];
                const label = xDomain.label;
                return {
                    value: rawValue,
                    label
                };
            })
        });
    });
}

export function getYearFromRetirement (desiredRetirementYears, bornYear) {
    return desiredRetirementYears - (new Date().getFullYear() - bornYear);
}

export function getTopLabels (data) {
    return _.map(data.mapRetirementYear, (x) => {
        let { value } = x;
        if (typeof value === "object") {
            value = value.value;
        }
        return Number(value) ? value : "Income";
    });
}

export default {
    getTopLabels,
    getGroups,
    getTdfRetirementYear,
    getAssetsAllocation,
    getYearFromRetirement
};



// WEBPACK FOOTER //
// ./src/logic.js